import { PlaceholderContainer } from '@topcon/topcon-utils';
import { useTranslation } from 'react-i18next';

function EmptyNotifications() {
  const { t } = useTranslation('notifications');

  return <PlaceholderContainer grow icon="notifications_none" text={t('noNotifications')} />;
}

export default EmptyNotifications;
